<div class="container1">
  <mat-card class="mat-card-customer mat-card-customer-general">
    <form [formGroup]="customerForm" (ngSubmit)="onSubmit()">
      <mat-card-header>
        <mat-card-title> {{ 'customer.general-informations' | translate}}</mat-card-title>
        <!-- <mat-card-subtitle>Informations générales</mat-card-subtitle> -->
      </mat-card-header>
      <mat-card-content class="mat-card-content-customer">
        <div class="content-row">
          <label class="content-row-label">{{ 'label.number' | translate}}</label>
          <!-- <mat-form-field class="content-row-input"> -->
          <!-- <input matInput formControlName="number" type="number" autocomplete="off"> -->
          <label class="content-row-input">{{ companyDetail?.company?.number ? (companyDetail?.company?.number | number
            :'6.0') : ''}}</label>
          <!-- </mat-form-field> -->
        </div>
        <div class="content-row">
          <label class="content-row-label">
          <span class="required-asterisk" *ngIf="isRequiredField('name')">*</span>{{ 'label.denomination' | translate}}</label>
          <mat-form-field class="content-row-input">
            <input matInput formControlName="name" type="text" autocomplete="off">
          </mat-form-field>
        </div>
        <div class="content-row">
          <label class="content-row-label">
          <span class="required-asterisk" *ngIf="isRequiredField('email')">*</span>{{ 'label.mail' | translate}}</label>
          <mat-form-field class="content-row-input">
            <input matInput formControlName="email" type="text" autocomplete="off">
          </mat-form-field>
        </div>
        <div class="content-row">
          <label class="content-row-label">
          <span class="required-asterisk" *ngIf="isRequiredField('ntva')">*</span>{{ 'label.vat' | translate}}</label>
          <mat-form-field class="content-row-input">
            <input matInput formControlName="ntva" type="text" autocomplete="off">
          </mat-form-field>
        </div>
        <div class="content-row">
          <label class="content-row-label">
          <span class="required-asterisk" *ngIf="isRequiredField('contactName')">*</span>{{ 'label.contact-person' | translate}}</label>
          <mat-form-field class="content-row-input">
            <input matInput formControlName="contactName" type="text" autocomplete="off">
          </mat-form-field>
        </div>

        <div formGroupName="address" class="mat-card-content-customer" style="width: 100%;">
          <div class="content-row">
            <label class="content-row-label">
            <span class="required-asterisk" *ngIf="isRequiredField('address.address1')">*</span>{{ 'label.address' | translate}}</label>
            <mat-form-field class="content-row-input">
              <input matInput formControlName="address1" type="text" autocomplete="off">
            </mat-form-field>
          </div>
          <div class="content-row">
            <label class="content-row-label">
            <span class="required-asterisk" *ngIf="isRequiredField('address.zip')">*</span>{{ 'label.zip' | translate}}</label>
            <mat-form-field class="content-row-input">
              <input matInput formControlName="zip" type="number" autocomplete="off">
            </mat-form-field>
          </div>
          <div class="content-row">
            <label class="content-row-label">
            <span class="required-asterisk" *ngIf="isRequiredField('address.city')">*</span>{{ 'label.city' | translate}}</label>
            <mat-form-field class="content-row-input">
              <input matInput formControlName="city" type="text" autocomplete="off">
            </mat-form-field>
          </div>
        </div>
      </mat-card-content>
      <mat-card-actions class="customer-card-action" *ngIf="uiService.visibleByRole([Role.manager, Role.administrator])">
        <button mat-raised-button color="warn" type="button" (click)="onDelete()"
          *ngIf="(companyDetail?.id || companyDetail?.company?.id ) && companyDetail?.isReadOnlyMode">
          <mat-icon>delete</mat-icon> {{ 'button.delete' | translate }}
        </button>
        <button mat-raised-button color="primary" type="button" (click)="onEdit()"
          *ngIf="(companyDetail?.id || companyDetail?.company?.id ) && companyDetail?.isReadOnlyMode">
          <mat-icon>edit</mat-icon> {{ 'button.edit' | translate }}
        </button>
        <button mat-raised-button color="warn" type="button" (click)="onCancel()"
          *ngIf="(companyDetail?.id || companyDetail?.company?.id ) && companyDetail?.isEditMode">
          <mat-icon>clear</mat-icon> {{ 'button.cancel' | translate }}
        </button>
        <button mat-raised-button color="primary" [disabled]="customerForm.invalid"
          *ngIf="companyDetail?.isEditMode || companyDetail?.isCreationMode">
          <mat-icon>save</mat-icon> {{ 'button.save' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>

  <!-- <mat-card class="mat-card-customer mat-card-customer-billing">
    <form [formGroup]="customerBillingForm" (ngSubmit)="onSubmit()">
      <mat-card-header>
        <mat-card-title>Données de facturation</mat-card-title>
      </mat-card-header>
      <mat-card-content class="mat-card-content-customer">
        <div class="content-row">
          <label class="content-row-label">Intitulé de facturation</label>
          <mat-form-field class="content-row-input">
            <input matInput formControlName="name" type="text" autocomplete="off">
          </mat-form-field>
        </div>

      </mat-card-content>
    </form>
  </mat-card> -->

</div>
<div class="container2">
  <mat-card class="mat-card-customer mat-card-customer-contract">
    <mat-card-header style="height: 50px;
    align-items: baseline; justify-content: space-between;">
      <mat-card-title>{{ 'customer.list-contract' | translate}}</mat-card-title>
      <button mat-mini-fab (click)="onCreateContract()" type="button" *ngIf="((companyDetail?.id || companyDetail?.company?.id )) 
      && (uiService.visibleByRole([Role.manager, Role.administrator]))" color="primary">
        <mat-icon>add</mat-icon>
      </button>
    </mat-card-header>
    <mat-card-content>
      <table mat-table [dataSource]="dataSource" matSort style="width: 100%;" matSortActive="name"
        matSortDirection="asc" class="mat-elevation-z2">

        <!-- name Column -->
        <ng-container matColumnDef="name">
          <th class="header" mat-header-cell *matHeaderCellDef>
            <div mat-sort-header>
              {{ 'label.name' | translate}}
            </div>
          </th>
          <td mat-cell *matCellDef="let element">
            <span> {{ element.name }}</span>
          </td>
        </ng-container>

        <!-- name Column -->
        <ng-container matColumnDef="action">
          <th class="header" mat-header-cell *matHeaderCellDef>
            <div mat-sort-header>

            </div>
          </th>
          <td mat-cell *matCellDef="let element">
            <button mat-raised-button color="primary" (click)="goToDetail(element)">
              <mat-icon>info</mat-icon>
              {{ 'label.detail' | translate}}
            </button>
          </td>
        </ng-container>

        <!-- <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>
          <button mat-button>
            <mat-icon>info</mat-icon>Détail
          </button>
        </th>
      </ng-container> -->

        <!-- <tr mat-header-row *matHeaderRowDef="['action']"> </tr> -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'highlight': selectedRowID == row.id}"
          (click)="selectItemClick(row)"></tr>
      </table>
      <!-- <mat-paginator #MatPaginatorContract class="m-5 mat-elevation-z2" [pageSizeOptions]="pageSizeOptions"
        showFirstLastButtons>
      </mat-paginator> -->
    </mat-card-content>
  </mat-card>

</div>